import React, { useState, useEffect } from "react";
import "../ListRoles/ListRoles.css";
import "../DashBoard/sliding.css";

import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import { roleReducer } from "../../Redux/store";
import SlidingPane from "react-sliding-pane";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

//import Backdrop from "@mui/material/Backdrop";
//import CircularProgress from "@mui/material/CircularProgress";

import {
  SuccessAlert,
  FailureAlert,
  InformationAlert,
  SuccessUpdate,
  FailureUpdate,
  SuccessDelete,
} from "../../components/Alert_msg/alert_msg";

function ListRoles() {
  // Dispatch
  const dispatch = useDispatch();

  //Permission for Roles
  const Add_Permission = useSelector(
    (state) => state.AccessTocken.Add_Permission
  );
  const Edit_Permission = useSelector(
    (state) => state.AccessTocken.Edit_Permission
  );
  const Delete_Permission = useSelector(
    (state) => state.AccessTocken.Delete_Permission
  );
  const View_Permission = useSelector(
    (state) => state.AccessTocken.View_Permission
  );

  //API related selectors
  const tocken = useSelector((state) => state.AccessTocken.accessTocken);
  const msToken = useSelector((state) => state.AccessTocken.o365token);
  const token = tocken ? tocken : msToken;

  //Role Edit related selectors
  const role_id = useSelector((state) => state.role.role_id);
  const role_name = useSelector((state) => state.role.role_name);
  const role_desp = useSelector((state) => state.role.role_desp);
  const role_type = useSelector((state) => state.role.role_type);

  //Add Role and Edit Role related selectors
  const role_edit = useSelector((state) => state.role.role_edit);
  const role_IsPane = useSelector((state) => state.role.roleIsPane);
  const addrole_IsPane = useSelector((state) => state.role.addroleIsPane);

  //state hook for listrole API's
  const [roleData, setroleData] = useState([]);
  // const [roleType, setroleType] = useState([]);
  // const [roleCount, setRoleCount] = useState(null);

  //state hook for Add role API's
  const [newRole, setNewRole] = useState(null);
  const [newDescription, setNewDescription] = useState(null);

  const [newRoleType, setnewRoleType] = useState(null);

  // let roleNameTable = "";
  // let char1 = "";
  // let roleName_F = "";
  let depend = 0;

  //state hook for Edit role API's
  const [roleId, setRoleId] = useState("");
  const [roleName, setRoleName] = useState(null);
  const [EditDesp, setEditDesp] = useState("");
  const [RoleType, setRoleType] = useState("");
  const [RoleTypeName, setRoleTypeName] = useState("");

  // filtering
  const [RoleFilter, setRoleFilter] = useState("");
  const [RoleselData, setRoleselData] = useState("");

  // const [isFiltered, setIsFiltered] = useState(false);
  // const [isFilterIReset, setIsFilterIReset] = useState(false);

  // const [dummyRolefilter, setDummyRolefilter] = useState("");
  // const [dummyRoleselData, setDummyRoleselData] = useState("");

  // const role_filter = useSelector((state) => state.role.role_filter);

  // for loading the API
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);

  // dependency
  const [IsDependent, setIsDependent] = useState(false);

  const tableHeight = false;

  //Add content pop up
  const [popUp, setPopUp] = useState(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 4,
  };

  //Header for API's
  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  //Pagenation
  // const [index1_pagenation, setIndex1_pagenation] = useState(1);
  // const [index2_pagenation, setIndex2_pagenation] = useState(2);
  // const [index3_pagenation, setIndex3_pagenation] = useState(3);
  // const [index4_pagenation, setIndex4_pagenation] = useState(4);
  // const [noOfPages, setNoOfPages] = useState(null);
  const [pageSelected, setPageSelected] = useState(1);
  const listLimit = useSelector((state) => state.AccessTocken.recordsPerPage);

  // const onPage = {
  //   cursor: "pointer",
  //   backgroundColor: "RGB(200, 200, 200)",
  //   scale: "1.2",
  // height: "25px",
  // };
  // const notOnPage = { cursor: "pointer", scale: "1" };

  // const leftArrow = () => {
  //   if (index1_pagenation !== 1) {
  //     setIndex1_pagenation(index1_pagenation - 1);
  //     setIndex2_pagenation(index2_pagenation - 1);
  //     setIndex3_pagenation(index3_pagenation - 1);
  //     setIndex4_pagenation(index4_pagenation - 1);
  //   }
  //   setPageSelected(pageSelected - 1);
  //   pagenationAPi(pageSelected - 1, RoleselData, RoleFilter);
  // };

  // const rightArrow = () => {
  //   if (noOfPages >= 4) {
  //     if (index4_pagenation !== noOfPages) {
  //       setIndex1_pagenation(index1_pagenation + 1);
  //       setIndex2_pagenation(index2_pagenation + 1);
  //       setIndex3_pagenation(index3_pagenation + 1);
  //       setIndex4_pagenation(index4_pagenation + 1);
  //     }
  //   }
  //   setPageSelected(pageSelected + 1);
  //   pagenationAPi(pageSelected + 1, RoleselData, RoleFilter);
  // };

  // const leftEndArrow = () => {
  //   setIndex1_pagenation(1);
  //   setIndex2_pagenation(2);
  //   setIndex3_pagenation(3);
  //   setIndex4_pagenation(4);
  //   pagenationAPi(1, RoleselData, RoleFilter);
  // };

  // const rightEndArrow = () => {
  //   if (noOfPages > 4) {
  //     setIndex1_pagenation(noOfPages - 3);
  //     setIndex2_pagenation(noOfPages - 2);
  //     setIndex3_pagenation(noOfPages - 1);
  //     setIndex4_pagenation(noOfPages);
  //   } else if (noOfPages <= 4) {
  //     setIndex1_pagenation(1);
  //     setIndex2_pagenation(2);
  //     setIndex3_pagenation(3);
  //     setIndex4_pagenation(4);
  //   }
  //   pagenationAPi(noOfPages, RoleselData, RoleFilter);
  // };

  // const pagenationAPi = async (pageNo, TargetColomn, keyWord) => {
  //   if (!isFiltered) {
  //     dispatch(sidebarReducer.apiLoad(true));
  //     setPageSelected(pageNo);
  //     await axios
  //       .get(`rolemanagement/list/?page=${pageNo}&limit=${listLimit}`, options)
  //       .then((response) => {

  //         if (response.status === 200) {
  //           dispatch(sidebarReducer.apiLoad(false));
  //           setroleData(response.data.data.rows);
  //         }

  //         else if (response.status !== 200) {
  //           dispatch(sidebarReducer.apiLoad(false));
  //           sessionStorage.clear();
  //           window.location.reload();
  //         }
  //       })
  //       .catch((err) => {
  //         dispatch(sidebarReducer.apiLoad(false));
  //         sessionStorage.clear();
  //         window.location.reload();
  //       });

  //   }
  //   else if (isFiltered) {
  //     setPageSelected(pageNo);
  //     if (!isFilterIReset) {
  //       dispatch(sidebarReducer.apiLoad(true));
  //       if (TargetColomn === "te_rolestatus") {
  //         let status = RoleFilter.toLowerCase();

  //         if (status === "active") {
  //           keyWord = "1";
  //         } else if (status === "inactive") {
  //           keyWord = "0";
  //         }
  //       }
  //       await axios
  //         .get(
  //           `rolemanagement/list/?page=${pageNo}&limit=${listLimit}&${TargetColomn}=${keyWord}`,
  //           options
  //         )
  //         .then((response) => {

  //           if (response.status === 200) {
  //             dispatch(sidebarReducer.apiLoad(false));
  //             setroleData(response.data.data.rows);
  //           }

  //           else if (response.status !== 200) {
  //             dispatch(sidebarReducer.apiLoad(false));
  //             sessionStorage.clear();
  //             window.location.reload();
  //           }
  //         })
  //         .catch((err) => {
  //           dispatch(sidebarReducer.apiLoad(false));
  //           sessionStorage.clear();
  //           window.location.reload();
  //         });
  //     }

  //     else if (isFilterIReset) {
  //       dispatch(sidebarReducer.apiLoad(true));

  //       if (dummyRoleselData === "te_rolestatus") {
  //         let status = dummyRolefilter.toLowerCase();
  //         if (status === "active") {
  //           keyWord = "1";
  //           // setDivfilter("1");
  //         } else if (status === "inactive") {
  //           keyWord = "0";
  //           // setDivfilter("0");
  //         }
  //       } else if (dummyRoleselData !== "te_rolestatus") {
  //         keyWord = dummyRolefilter;
  //       }
  //       await axios
  //         .get(
  //           `rolemanagement/list/?page=${pageNo}&limit=${listLimit}&${dummyRoleselData}=${keyWord}`,
  //           options
  //         )
  //         .then((response) => {

  //           if (response.status === 200) {
  //             dispatch(sidebarReducer.apiLoad(false));
  //             setroleData(response.data.data.rows);
  //           }

  //           else if (response.status !== 200) {
  //             dispatch(sidebarReducer.apiLoad(false));
  //             sessionStorage.clear();
  //             window.location.reload();
  //           }
  //         })
  //         .catch((err) => {
  //           sessionStorage.clear();
  //           window.location.reload();
  //           dispatch(sidebarReducer.apiLoad(false));
  //         });
  //     }
  //   }
  // };

  // axios API
  async function responseData() {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`roles/list?page=${pageSelected}&limit=${listLimit}`, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          // let pages = Math.ceil(response.data.data.count / listLimit);
          //  setNoOfPages(pages);

          // setRoleCount(response.data.data.count);
          return setroleData(response.data.data.rows);

          //Role name
          // roleNameTable = response.data.rows[0].te_role_name.toLowerCase();
          // console.log(roleNameTable, "iiiiiiiiiiiiiiii");
          // char1 = roleName[0].toUpperCase();
          // roleName_F = roleNameTable.replace(roleNameTable[0], char1);
          // console.log({ roleNameTable, char1, roleName_F });
        } else if (response.status !== 200) {
          // sessionStorage.clear();
          // window.location.reload();
          dispatch(sidebarReducer.apiLoad(false));
        }
      })
      .catch((err) => {
        // sessionStorage.clear();
        // window.location.reload();
        dispatch(sidebarReducer.apiLoad(false));
      });
  };

  // const RoleTypeResponse = async () => {
  //   // dispatch(sidebarReducer.apiLoad(true));
  //   await axios
  //     .get(`businessunit/listactive`, options)

  //     .then((response) => {
  //       if (response.status === 200) {
  //         dispatch(sidebarReducer.apiLoad(false));
  //         setroleType(response.data.data);
  //       }
  //       else if (response.status !== 200) {
  //         dispatch(sidebarReducer.apiLoad(false));
  //         sessionStorage.clear();
  //         window.location.reload();
  //       }
  //     })
  //     .catch((err) => {
  //       dispatch(sidebarReducer.apiLoad(false));
  //       sessionStorage.clear();
  //       window.location.reload();
  //     });
  // };




  //Add Role API
  const newAddRole_data = {
    roleName: newRole,
    roleDescription: newDescription,
    roleType: newRoleType,
  };

  const onAddRole = async (e) => {
    e.preventDefault();
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .post("roles/add", newAddRole_data, options)
      .then((response) => {
        if (response.status === 200) {
          if (
            response.data.message ===
            `Role '${newAddRole_data.roleName}' already exists`
          ) {
            dispatch(sidebarReducer.information(true));
          } else {
            dispatch(sidebarReducer.success(true));
          }

          dispatch(roleReducer.addrole_IsPane(false));
          dispatch(sidebarReducer.apiLoad(false));
          setNewDescription("");
          setnewRoleType("");
          setNewRole("");
          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));

          dispatch(sidebarReducer.apiLoad(false));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));

        dispatch(sidebarReducer.success(false));
        dispatch(sidebarReducer.failure(true));
        dispatch(sidebarReducer.apiLoad(false));
      });

    // console.log(response);
  };

  //Update Role API
  const newRole_data = {
    roleId: roleId,
    roleName: roleName,
    roleDescription: EditDesp,
    roleType: RoleType,
  };

  const onUpdate = async (roleId) => {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .put(`roles/update/${roleId}`, newRole_data, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(roleReducer.role_edit(false));
          dispatch(sidebarReducer.stringUpdate("ListRoles"));
          dispatch(roleReducer.role_IsPane(false));

          dispatch(sidebarReducer.update_success(true));
          dispatch(sidebarReducer.apiLoad(false));

          responseData();
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.apiLoad(false));
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));

        dispatch(sidebarReducer.apiLoad(false));
        dispatch(sidebarReducer.update_failure(true));
        dispatch(sidebarReducer.update_success(false));
      });
  };

  //Delete user API
  const onDelete = async (id) => {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .post(`roles/delete/${id}`, {}, options)
      .then((response) => {
        if (response.status === 200) {
          dispatch(roleReducer.role_edit(false));
          dispatch(sidebarReducer.stringUpdate("ListRoles"));
          dispatch(roleReducer.role_IsPane(false));
          dispatch(sidebarReducer.delete_success(true));
          dispatch(sidebarReducer.apiLoad(false));
          responseData();
        } else if (response.status !== 200) {
                    dispatch(sidebarReducer.stringUpdate("AppDown"));

          dispatch(sidebarReducer.apiLoad(false));
        }
      })
      .catch((err) => {
                  dispatch(sidebarReducer.stringUpdate("AppDown"));

        dispatch(sidebarReducer.apiLoad(false));
      });
  };

  //Cancel button function
  async function onCancel() {
    dispatch(sidebarReducer.apiLoad(true));
    await axios
      .get(`roles/list/${role_id}`, options)
      .then((response) => {
        if (response.status === 200) {
          // console.log(response.data.data.rows[0].te_rolestatus, "roleeeeeeeee");
          setRoleName(role_name);
          setEditDesp(role_desp);
          setRoleType(role_type);
          setRoleTypeName(role_type);

          dispatch(roleReducer.role_edit(false));
          dispatch(sidebarReducer.apiLoad(false));
        } else if (response.status !== 200) {
                    dispatch(sidebarReducer.stringUpdate("AppDown"));

          dispatch(sidebarReducer.apiLoad(false));
        }
      })
      .catch((err) => {
                 dispatch(sidebarReducer.stringUpdate("AppDown"));

        dispatch(sidebarReducer.apiLoad(false));
      });
  }

  // useEffect hook
  useEffect(() => {
    if (View_Permission === 1) {
      responseData();
    }
    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [depend]);

  // filter search function
  // const handleSearch = async (e, TargetColomn, keyWord) => {
  //   e.preventDefault();
  //   dispatch(sidebarReducer.apiLoad(true));
  //   if (TargetColomn === "te_rolestatus") {
  //     let status = RoleFilter.toLowerCase();

  //     if (status === "active") {
  //       keyWord = "1";
  //     } else if (status === "inactive") {
  //       keyWord = "0";
  //     }
  //   }

  //   await axios
  //     .get(
  //       // `rolemanagement/list?page=${pageSelected}&${TargetColomn}=${keyWord}`,
  //       `rolemanagement/list?limit=${listLimit}&${TargetColomn}=${keyWord}`,
  //       options
  //     )
  //     .then((response) => {
  //       if (response.status === 200) {
  //         setroleData(response.data.data.rows);
  //         setRoleCount(response.data.data.count);
  //         dispatch(sidebarReducer.apiLoad(false));
  //         let pages = Math.ceil(response.data.data.count / listLimit);
  //         setNoOfPages(pages);
  //       }

  //       else if (response.status !== 200) {
  //         dispatch(sidebarReducer.apiLoad(false));
  //         sessionStorage.clear();
  //         window.location.reload();
  //       }
  //     })
  //     .catch((err) => {
  //       dispatch(sidebarReducer.apiLoad(false));
  //       sessionStorage.clear();
  //       window.location.reload();
  //     });
  // };

  async function onEdit(item) {
    await axios
      .get(`roles/details/${item.te_role_id}`, options)
      .then((response) => {
        if (response.status === 200) {
          //  dispatch(sidebarReducer.apiLoad(false));

          setRoleId(response.data.data.te_role_id);
          setRoleName(response.data.data.te_role_name);
          setEditDesp(response.data.data.te_role_description);
          setRoleType(response.data.data.te_role_type);
          setRoleTypeName(response.data.data.te_role_type);
          setIsDependent(response.data.data.dependency);

          dispatch(roleReducer.role_id(response.data.data.te_role_id));
          dispatch(roleReducer.role_name(response.data.data.te_role_name));
          dispatch(roleReducer.role_desp(response.data.data.te_role_desp));
          dispatch(roleReducer.role_type(response.data.data.te_role_type));
          dispatch(roleReducer.role_IsPane(true));
        } else if (response.status !== 200) {
          console.log(response.status);
                    dispatch(sidebarReducer.stringUpdate("AppDown"));

          //  dispatch(sidebarReducer.apiLoad(false));
          // sessionStorage.clear();
          // window.location.reload();
        }
      })

      .catch((err) => {
        console.log(err);
                  dispatch(sidebarReducer.stringUpdate("AppDown"));

        // dispatch(sidebarReducer.apiLoad(false));
        // sessionStorage.clear();
        // window.location.reload();
      });
  }
  //Clear button inside accordion
  const handleReset1 = (e) => {
    setRoleFilter("");
    setRoleselData("");
    responseData();
  };

  return (
    <div>
      {View_Permission === 1 ? (
        <div className="container-fluid">
          {/** total content part in the layout */}
          <div className="row">
            <div className="col-12 p-0" style={{ minHeight: "84.6vh" }}>
              {/** ROW 1 for header */}
              <div className="row g-0 p-0">
                <div className="col">
                  <div
                    className="g-0 m-0 border-top"
                    style={{ backgroundColor: "#f2f3f5" }}
                  >
                    <div className="row p-0">
                      <div className="col-6" style={{ height: "50px" }}>
                        <div className="d-flex flex-row">
                          <div className="p-2 mt-1">
                            <h5>
                              <strong>Roles</strong>
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="d-flex flex-row-reverse me-3">
                          {/* Filer button */}
                          <div className="p-2">
                            <button
                              className="btn"
                              style={{
                                backgroundColor: "var(--themes-color)",
                                color: "white",
                                minWidth: "100px",
                              }}
                              onClick={() => {
                                if (Add_Permission === 1) {
                                  dispatch(roleReducer.addrole_IsPane(true));
                                }
                              }}
                            >
                              <span
                                className="ToolTipU"
                                style={{
                                  backgroundColor: "var(--themes-color)",
                                }}
                              >
                                <i className="bi bi-plus-lg"></i>&nbsp; Add Role
                                <span
                                  className="ToolTipTextU"
                                  style={{
                                    backgroundColor:
                                      Add_Permission === 1
                                        ? "var(--themes-color)"
                                        : "red",
                                  }}
                                >
                                  {Add_Permission === 1
                                    ? "You can add a Role."
                                    : "You cannot add a Role."}
                                </span>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/** ROW 2 for table */}
              <div className="row g-0 p-0">
                <div className="col">
                  <div className="">
                    {!role_IsPane && !addrole_IsPane && (
                      <div className="accordion" id="accordionExample">
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div
                            className="row accordion-body d-flex align-items-end p-2 "
                            style={{
                              backgroundColor: "#E3F7F9",
                              height: "90px",
                            }}
                          >
                            <div className="container">
                              <div className="row justify content start">
                                <div
                                  className="col-3"
                                  style={{
                                    // backgroundColor: "red",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <TextField
                                    label="keyword"
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                      "& > :not(style)": {
                                        zIndex: "0",
                                      },
                                    }}
                                    value={RoleFilter}
                                    onChange={(e) => {
                                      let val = e.target.value;
                                      setRoleFilter(val);
                                      //  setDummyRolefilter(val);
                                    }}
                                  />
                                </div>

                                <div
                                  className="col-3"
                                  style={{
                                    // backgroundColor: "yellow",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <FormControl sx={{ width: "90%" }}>
                                    <InputLabel
                                      id="demo-simple-select-label"
                                      style={{ zIndex: "0" }}
                                      size="small"
                                    >
                                      Target Column
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-label"
                                      id="demo-simple-select"
                                      label="Target Columns"
                                      value={RoleselData}
                                      size="small"
                                      onChange={(e) => {
                                        let val = e.target.value;
                                        setRoleselData(val);
                                        //setDummyRoleselData(val);
                                      }}
                                    >
                                      <MenuItem
                                        value="te_rolename"
                                        size="small"
                                      >
                                        {" "}
                                        Role Name
                                      </MenuItem>
                                      <MenuItem
                                        value="te_rolestatus"
                                        size="small"
                                      >
                                        Status
                                      </MenuItem>
                                    </Select>
                                  </FormControl>
                                </div>

                                <div
                                  className="col-2"
                                  style={{
                                    // backgroundColor: "blue",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <button
                                    className="btn add-button text-white "
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "70px",
                                    }}
                                    onClick={(e) => {
                                      // handleSearch(e, RoleselData, RoleFilter);
                                      // setIsFiltered(true);
                                      // setIsFilterIReset(false);
                                      setPageSelected(1);
                                    }}
                                    disabled={
                                      RoleFilter.length > 0 &&
                                      RoleselData.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Filter
                                  </button>
                                </div>

                                <div
                                  className="col-2"
                                  style={{
                                    // backgroundColor: "green",
                                    height: "80px",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <button
                                    className="btn text-white"
                                    style={{
                                      backgroundColor: "var(--themes-color)",
                                      height: "40px",
                                      width: "70px",
                                    }}
                                    onClick={() => {
                                      handleReset1();
                                      // setIsFilterIReset(true);
                                    }}
                                    disabled={
                                      RoleFilter.length > 0 &&
                                      RoleselData.length > 0
                                        ? false
                                        : true
                                    }
                                  >
                                    Reset
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/** ROW 2 for table */}
                    {tableHeight ? (
                      <div
                        className="table-wrapper-scroll-y my-custom-scrollbar"
                        style={{ minHeight: "60vh" }}
                      >
                        {apiLoad ? (
                          <div
                            style={{
                              height: "80vh",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div className="spinnerApi"></div>
                          </div>
                        ) : (
                          <table className="table table-hover ListUserTable border">
                            <thead style={{ backgroundColor: "#ecedef" }}>
                              <tr style={{ textAlign: "left" }} e="true">
                                <th className="border">Sl.No</th>
                                <th className="border">Role Name</th>
                                <th className="border">Description</th>
                                <th className="border">Role Type</th>
                              </tr>
                            </thead>
                            <tbody className="text-start ">
                              {roleData.length === 0 ? (
                                // <tbody>
                                <tr>
                                  <td
                                    colSpan={3}
                                    className=" border text-center mb-0"
                                  >
                                    No Data Found
                                  </td>
                                </tr>
                              ) : (
                                // </tbody>
                                roleData.map((item, index) => (
                                  <tr
                                    key={index}
                                    onClick={() => {
                                      onEdit(item);
                                      console.log("clickedd");
                                      // handleReset();
                                    }}
                                    style={{
                                      backgroundColor: `${
                                        item.te_roleid === role_id &&
                                        role_IsPane === true
                                          ? " #f2f3f5"
                                          : " #fff"
                                      }`,
                                    }}
                                  >
                                    <td className="border text-start">
                                      {index +
                                        1 +
                                        listLimit * (pageSelected - 1)}
                                    </td>
                                    <td
                                      className="border  text-start"
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {item.te_role_name.replace("_", " ")}
                                    </td>
                                    <td
                                      className="border  text-start"
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {item.te_role_description}
                                    </td>
                                    <td
                                      className="border  text-start"
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {item.te_role_type.replace("_", " ")}
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        )}
                      </div>
                    ) : (
                      <div
                        className="table-wrapper-scroll-y my-custom-scrollbar"
                        style={{ minHeight: "90vh" }}
                      >
                        {apiLoad ? (
                          <div
                            style={{
                              height: "80vh",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <div className="spinnerApi"></div>
                          </div>
                        ) : (
                          <table className="table table-hover ListUserTable border">
                            <thead style={{ backgroundColor: "#ecedef" }}>
                              <tr style={{ textAlign: "left" }} e="true">
                                <th className="border">Sl.No</th>
                                <th className="border">Role Name</th>
                                <th className="border">Description</th>
                                <th className="border">Role Type</th>
                              </tr>
                            </thead>
                            <tbody className="text-start ">
                              {roleData.length === 0 ? (
                                // <tbody>
                                <tr>
                                  <td
                                    colSpan={3}
                                    className=" border text-center mb-0"
                                  >
                                    No Data Found
                                  </td>
                                </tr>
                              ) : (
                                // </tbody>
                                roleData.map((item, index) => {
                                  return (
                                    <tr
                                      key={index}
                                      onClick={() => {
                                        onEdit(item);
                                        console.log("clickedd");
                                        // handleReset();
                                      }}
                                      style={{
                                        backgroundColor: `${
                                          item.te_roleid === role_id &&
                                          role_IsPane === true
                                            ? " #f2f3f5"
                                            : " #fff"
                                        }`,
                                      }}
                                    >
                                      <td className="border text-start">
                                        {index +
                                          1 +
                                          listLimit * (pageSelected - 1)}
                                      </td>
                                      <td className="border  text-start">
                                        {item.te_role_name.replace("_", " ")}
                                      </td>
                                      <td
                                        className="border  text-start"
                                        style={{ textTransform: "capitalize" }}
                                      >
                                        {item.te_role_description}
                                      </td>
                                      <td
                                        className="border  text-start"
                                        style={{ textTransform: "capitalize" }}
                                      >
                                        {item.te_role_type.replace("_", " ")}
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </table>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* pagination footer */}
            {/* <div className="container">
              <div className="row main-footer">
                <div className="col-3 mt-2" style={{ whiteSpace: "nowrap" }}>
                  Total Records: {roleCount}
                </div>
                <div className="col-4 mt-2">
                  <div className="d-flex justify-content-center ">
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-double-left"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          leftEndArrow();
                        }}
                      ></i>
                    </div>
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-left"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          pageSelected !== 1 && leftArrow();
                        }}
                      ></i>
                    </div>
                    <div
                      className={
                        noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                      }
                      style={
                        index1_pagenation === pageSelected ? onPage : notOnPage
                      }
                      onClick={() => {
                        pagenationAPi(
                          index1_pagenation,
                          RoleselData,
                          RoleFilter
                        );
                      }}
                    >
                      {index1_pagenation}
                    </div>
                    {noOfPages > 1 && (
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index2_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index2_pagenation,
                            RoleselData,
                            RoleFilter
                          );
                        }}
                      >
                        {index2_pagenation}
                      </div>
                    )}
                    {noOfPages > 2 && (
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index3_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index3_pagenation,
                            RoleselData,
                            RoleFilter
                          );
                        }}
                      >
                        {index3_pagenation}
                      </div>
                    )}
                    {noOfPages > 3 && (
                      <div
                        className={
                          noOfPages > 4 ? "px-2 mx-1 rounded" : "px-2 rounded"
                        }
                        style={
                          index4_pagenation === pageSelected
                            ? onPage
                            : notOnPage
                        }
                        onClick={() => {
                          pagenationAPi(
                            index4_pagenation,
                            RoleselData,
                            RoleFilter
                          );
                        }}
                      >
                        {index4_pagenation}
                      </div>
                    )}
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-right"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          pageSelected !== noOfPages && rightArrow();
                        }}
                      ></i>
                    </div>
                    <div className={noOfPages > 4 ? "" : ""}>
                      <i
                        className="bi bi-chevron-double-right"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          rightEndArrow();
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
                <div className="col-3 mt-2 ">
                  <div className="d-flex justify-content-end">
                    <span>
                      <strong>Page {pageSelected} </strong> of{" "}
                      <strong>{noOfPages}</strong>
                    </span>
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          {/** SlidingPan pop up for selecting and editing user data */}
          {
            <SlidingPane
              className="some-custom-class"
              overlayClassName="some-custom-overlay-class"
              width="71%"
              hideHeader
              isOpen={role_IsPane}
              onRequestClose={() => {
                // triggered on "<" on left top click or on outside click
                // onCancel();
              }}
            >
              <div
                className="container-fluid"
                style={{ backgroundColor: "#f2f3f5", height: "54px" }}
              >
                <div className="row" style={{ height: "54px" }}>
                  <div className="col-3">
                    <div className="d-flex align-items-center ">
                      <div
                        className="px-1 pt-1"
                        onClick={() => {
                          dispatch(roleReducer.role_edit(false));
                          dispatch(sidebarReducer.stringUpdate("ListRoles"));
                          dispatch(roleReducer.role_IsPane(false));
                        }}
                      >
                        <i className="bi bi-arrow-right"></i>
                      </div>
                      <div
                        className="border-start"
                        // className="px-2 pt-3 pb-1 border-secondary border-opacity-25 border-start"
                        style={{ height: "54px" }}
                      >
                        <h5 className="px-1 pt-3">
                          <strong>{role_name}</strong>
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div className="col-9" style={{ height: "54px" }}>
                    <div
                      className="d-flex flex-row-reverse bd-highlight"
                      style={{ height: "54px" }}
                    >
                      <div
                        className="p-0 border-start"
                        // style={{ backgroundColor: "red" }}
                      >
                        {role_edit ? (
                          <button
                            className="button"
                            style={{
                              // paddingTop: "3px",
                              border: "none",
                              height: "54px",
                            }}
                            onClick={() => onUpdate(roleId)}
                          >
                            <i className="bi bi-file-earmark-diff-fill"></i>
                            &nbsp;Save Changes
                          </button>
                        ) : (
                          <button
                            className="button"
                            style={{
                              zIndex: "1100",
                              // paddingTop: "3px",
                              border: "none",
                              height: "54px",
                            }}
                            onClick={() =>
                              Edit_Permission === 1 &&
                              dispatch(roleReducer.role_edit(!role_edit))
                            }
                          >
                            <span
                              className="ToolTipPEdit"
                              // style={{
                              //   backgroundColor: "var(--themes-color)",
                              // }}
                            >
                              <i className="bi bi-pencil-fill"></i>&nbsp; Edit
                              Record
                              <span
                                className="ToolTipTextPEdit"
                                style={{
                                  backgroundColor:
                                    Edit_Permission === 1
                                      ? "var(--themes-color)"
                                      : "red",
                                }}
                              >
                                {Edit_Permission === 1
                                  ? "You can edit the Role."
                                  : "You cannot edit the Role."}
                              </span>
                            </span>
                          </button>
                        )}
                      </div>
                      {role_edit && (
                        <div
                          className=" border-start "
                          style={{ height: "54px" }}
                          onClick={onCancel}
                        >
                          <button
                            className="button"
                            style={{
                              // paddingTop: "3px",
                              border: "none",
                              height: "54px",
                              minWidth: "85px",
                            }}
                          >
                            <i className="bi bi-arrow-clockwise"></i>
                            &nbsp;Cancel Changes
                          </button>
                        </div>
                      )}
                      <div className="p-0 border-start">
                        <button
                          className="button"
                          // data-bs-toggle="modal"
                          data-bs-target="#DeleteUser"
                          // data-backdrop="false"
                          style={{
                            zIndex: "1100",
                            border: "none",
                            height: "54px",
                            minWidth: "85px",
                          }}
                          onClick={() => {
                            setPopUp(true);
                          }}
                        >
                          <span
                            className="ToolTipPEdit"
                            style={
                              {
                                // backgroundColor:
                                //   "var(--themes-color)"
                              }
                            }
                          >
                            <i className="bi bi-trash-fill"></i>&nbsp; Delete
                            record
                            <span
                              className="ToolTipTextPEdit"
                              style={{
                                backgroundColor:
                                  Delete_Permission === 1
                                    ? "var(--themes-color)"
                                    : "red",
                              }}
                            >
                              {Delete_Permission === 1
                                ? "You can delete the Role."
                                : "You cannot delete the Role."}
                            </span>
                          </span>
                        </button>
                      </div>
                      <div className="mode" style={{ padding: "14px" }}>
                        <div className="d-flex justify-content-center">
                          <i>
                            <strong style={{ color: "blue" }}>
                              {role_edit ? "Edit Mode" : "View Mode"}
                            </strong>
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row contentscroll" style={{ width: "101.1%" }}>
                <div className="col ms-3 mt-2">
                  {/* <h5>Basic information:</h5> */}
                  <form style={{ width: "99%" }}>
                    <div className="mb-3">
                      <TextField
                        type="text"
                        className="form-control mt-2"
                        id="formGroupExampleInput"
                        label="Name"
                        value={roleName}
                        variant="outlined"
                        size="small"
                        onChange={(e) => setRoleName(e.target.value)}
                        disabled={role_edit ? false : true}
                      />
                    </div>
                    <div className="mb-3">
                      <TextField
                        type="text"
                        className="form-control mt-2"
                        id="formGroupExampleInput"
                        label="Description"
                        value={EditDesp}
                        variant="outlined"
                        size="small"
                        onChange={(e) => setEditDesp(e.target.value)}
                        disabled={role_edit ? false : true}
                      />
                      {/* <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label" size="small">
                         
                          Status
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={EditDesp}
                          disabled={role_edit ? false : true}
                          label="nactive"
                          variant="outlined"
                          size="small"
                          onChange={(e) => {
                            let val = e.target.value;
                            setEditDesp(val);

                          }}
                        >
                          <MenuItem value="1">Active</MenuItem>
                          <MenuItem value="0">Inactive</MenuItem>
                        </Select>
                      </FormControl> */}
                    </div>
                    <div
                      className="mb-3"
                      onMouseDown={() => {
                        if (role_edit) setRoleTypeName("Role Type");
                      }}
                    >
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label" size="small">
                          {RoleTypeName}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          disabled={role_edit ? false : true}
                          label="Role Type"
                          variant="outlined"
                          onChange={(e) => {
                            setRoleType(e.target.value);
                          }}
                        >
                          <MenuItem value="cms_user">CMS User</MenuItem>
                          <MenuItem value="remote_user">Remote User</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                    <br />
                  </form>
                </div>
              </div>
            </SlidingPane>
          }

          {/** SlidingPan pop up for adding new role data */}
          <SlidingPane
            className="some-custom-class"
            overlayClassName="some-custom-overlay-class"
            width="71%"
            hideHeader
            isOpen={addrole_IsPane}
            onRequestClose={() => {
              // triggered on "<" on left top click or on outside click
              // onCancel();
            }}
          >
            <div
              className="container-fluid m-0 g-0 border"
              style={{ backgroundColor: "#f2f3f5" }}
            >
              <div className="col-3">
                <div className="d-flex align-items-center flex-row">
                  <div
                    className="px-2 my-1"
                    onClick={() => {
                      dispatch(sidebarReducer.stringUpdate("ListRoles"));
                      dispatch(roleReducer.addrole_IsPane(false));
                    }}
                  >
                    <i className="bi bi-arrow-right"></i>
                  </div>
                  <div className="px-2 pt-2 pb-1 border-secondary border-opacity-25 border-start">
                    <h5 style={{ whiteSpace: "nowrap" }}>
                      <strong>Add Roles</strong>
                    </h5>
                  </div>
                </div>
              </div>
              <div className="col-9"></div>
            </div>

            <div className="row contentscroll" style={{ width: "101.5%" }}>
              <div className="col ms-3 mt-2">
                <form onSubmit={onAddRole} style={{ width: "99%" }}>
                  <div className="mb-3">
                    <TextField
                      type="text"
                      className="form-control mt-2"
                      id="formGroupExampleInput"
                      label="Name"
                      variant="outlined"
                      size="small"
                      required
                      onChange={(e) => setNewRole(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <TextField
                      type="text"
                      className="form-control mt-2"
                      id="formGroupExampleInput"
                      label="Description"
                      variant="outlined"
                      size="small"
                      required
                      onChange={(e) => setNewDescription(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        size="small"
                        required
                      >
                        Role Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        // value={age}
                        size="small"
                        label="Role Type"
                        variant="outlined"
                        required
                        onChange={(e) => {
                          let val = e.target.value;
                          setnewRoleType(val);
                        }}
                      >
                        <MenuItem value="cms_user">CMS User</MenuItem>
                        <MenuItem value="remote_user">Remote User</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                  <div className="mt-3">
                    <button
                      className="btn btn-light text-white"
                      type="submit"
                      style={{ backgroundColor: "var(--themes-color)" }}
                    >
                      &nbsp;Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </SlidingPane>
          <Modal
            open={popUp}
            // onClose={}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <center>
                <div
                  style={{
                    overflowY: "auto",
                  }}
                >
                  <h6>
                    {IsDependent
                      ? " This Role has dependency, Cannot delete this Role."
                      : "Are you sure you want to delete this Role?"}
                  </h6>
                </div>

                <div className="pt-4">
                  {!IsDependent && (
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      style={{
                        // backgroundColor: "var(--themes-color)",
                        width: "100px",
                      }}
                      onClick={() => {
                        setPopUp(false);
                        onDelete(roleId);
                      }}
                    >
                      Delete
                    </button>
                  )}
                  &nbsp; &nbsp; &nbsp;
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    style={{
                      // backgroundColor: "var(--themes-color)",
                      width: "100px",
                    }}
                    onClick={() => {
                      setPopUp(false);
                    }}
                  >
                    Close
                  </button>
                </div>
              </center>
            </Box>
          </Modal>
          {/* <div className="backdrop">
            <Backdrop
              sx={{
                color: "var(--themes-color)",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={apiLoad}
            //onClick={handleClose}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </div> */}
          <SuccessAlert />
          <FailureAlert />
          <InformationAlert />
          <SuccessUpdate />
          <FailureUpdate />
          <SuccessDelete />
        </div>
      ) : (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "red",
          }}
        >
          <h3>You do not have permission to view this page.</h3>
        </div>
      )}
    </div>
  );
}

export default ListRoles;
